export enum TowerActivityEnum {
  Drying = 'drying',
  Regenerating = 'regenerating',
}

export enum DesiccantExtendedActivityEnum {
  Off = 'off',
  On = 'on',
}
